export default __webpack_public_path__ + "static/media/documents.67b6717b.svg";